import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

const StyledIcon = styled.svg`
    fill: #DBC7A7;
    margin: ${rem('0px')} ${rem('7px')} ${rem('0px')} ${rem('3px')};
`;

const ExclamationTriangle= () => {
  return (
    <StyledIcon xmlns="http://www.w3.org/2000/svg" width="12.075" height="10.733" viewBox="0 0 12.075 10.733">
      <defs></defs><path d="M11.938,9.224a1.007,1.007,0,0,1-.872,1.509H1.007A1.007,1.007,0,0,1,.135,9.224L5.165.5A1.007,1.007,0,0,1,6.909.5l5.03,8.721Zm-5.9-1.8A.964.964,0,1,0,7,8.385.964.964,0,0,0,6.037,7.421ZM5.121,3.955l.156,2.851a.252.252,0,0,0,.251.238H6.546A.252.252,0,0,0,6.8,6.806l.156-2.851A.252.252,0,0,0,6.7,3.689H5.373a.252.252,0,0,0-.251.265Z" transform="translate(0)"/>
    </StyledIcon>
  )
}

export default ExclamationTriangle;